import Cards from './components/Cards';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css'
import { Menu } from './components/Menu/Menu';
import HouseDetails from './components/HouseDetails/HouseDetails';
import Footer from './components/Footer/Footer';
import React from 'react';

const App = () => {
  const [footerData, setFooterData] = React.useState([])
  React.useEffect(()=>{
    console.log("footerData333",footerData)
  },[footerData])
  return (
    <Router>
      <Menu />
      <Routes>
        <Route path='/' exact element={<Cards setFooterData={setFooterData} />} />
        <Route path='/:id' exact element={<HouseDetails />} />
      </Routes>
      <Footer footerData={footerData} />
    </Router>
  )
};


export default App;
